if (!customElements.get('sok-film')) {
  class SokFilm extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('[data-sok-video]');
      if (!this.video) return;
      const $ = (s) => this.querySelector(s);
      this.seekBar = $('[data-sok-seek]');
      this.progress = $('[data-sok-progress]');
      this.buffered = $('[data-sok-buffered]');
      this.knob = $('[data-sok-knob]');
      this.tip = $('[data-sok-tip]');
      this.time = $('[data-sok-time]');
      this.bufferIcon = $('[data-sok-buffer]');
      this.coverLabel = $('[data-sok-cover-label]');

      $('[data-sok-play]').addEventListener('click', () => this.play());
      $('[data-sok-toggle]').addEventListener('click', () => this.toggle());
      $('[data-sok-back]').addEventListener('click', () => (this.video.currentTime = Math.max(0, this.video.currentTime - 10)));
      $('[data-sok-mute]').addEventListener('click', () => {
        this.video.muted = !this.video.muted;
        this.classList.toggle('is-muted', this.video.muted);
      });
      $('[data-sok-fullscreen]').addEventListener('click', () => {
        const request = this.requestFullscreen || this.webkitRequestFullscreen;
        if (request) request.call(this);
        else if (this.video.webkitEnterFullscreen) this.video.webkitEnterFullscreen();
      });
      this.video.addEventListener('click', () => this.toggle());

      this.seekBar.addEventListener('click', (e) => this.seek(e));
      this.seekBar.addEventListener('mousemove', (e) => this.hoverBar(e));
      this.seekBar.addEventListener('mouseleave', () => (this.tip.hidden = true));
      this.seekBar.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') this.video.currentTime += 5;
        if (e.key === 'ArrowLeft') this.video.currentTime -= 5;
      });

      this.addEventListener('mousemove', () => this.wake());
      this.addEventListener('mouseleave', () => this.sleep());

      const v = this.video;
      v.addEventListener('loadedmetadata', () => this.render());
      v.addEventListener('durationchange', () => this.render());
      v.addEventListener('timeupdate', () => this.render());
      v.addEventListener('progress', () => {
        if (v.buffered.length && v.duration) this.buffered.style.width = `${(v.buffered.end(v.buffered.length - 1) / v.duration) * 100}%`;
      });
      v.addEventListener('play', () => this.setPlaying(true));
      v.addEventListener('pause', () => this.setPlaying(false));
      v.addEventListener('waiting', () => (this.bufferIcon.hidden = false));
      v.addEventListener('playing', () => (this.bufferIcon.hidden = true));
      v.addEventListener('ended', () => {
        this.classList.remove('is-started', 'is-chrome');
        v.currentTime = 0;
      });
      v.addEventListener('error', () => {
        this.classList.remove('is-started');
        this.coverLabel.textContent = this.dataset.error;
      });
    }

    format(t) {
      t = Math.max(0, Math.floor(t || 0));
      return `${Math.floor(t / 60)}:${String(t % 60).padStart(2, '0')}`;
    }

    render() {
      const { currentTime: cur, duration: dur } = this.video;
      const pct = dur ? (cur / dur) * 100 : 0;
      this.progress.style.width = `${pct}%`;
      this.knob.style.left = `${pct}%`;
      this.seekBar.setAttribute('aria-valuenow', Math.round(pct));
      this.time.textContent = `${this.format(cur)} / ${this.format(dur)}`;
      if (!this.classList.contains('is-started') && isFinite(dur)) {
        this.coverLabel.textContent = `${this.dataset.label} · ${this.format(dur)}`;
      }
    }

    play() {
      this.classList.add('is-started');
      this.video.play();
      this.wake();
    }

    toggle() {
      if (!this.classList.contains('is-started') || this.video.paused) this.play();
      else this.video.pause();
    }

    setPlaying(playing) {
      this.classList.toggle('is-playing', playing);
      if (!playing) this.classList.add('is-chrome');
      else this.wake();
    }

    wake() {
      if (!this.classList.contains('is-started')) return;
      clearTimeout(this.idleTimer);
      this.classList.add('is-chrome');
      this.classList.remove('is-idle');
      this.idleTimer = setTimeout(() => this.sleep(), 2200);
    }

    sleep() {
      clearTimeout(this.idleTimer);
      if (this.video.paused) return;
      this.classList.remove('is-chrome');
      this.classList.add('is-idle');
    }

    seek(event) {
      if (!this.video.duration) return;
      const rect = this.seekBar.getBoundingClientRect();
      this.video.currentTime = Math.min(1, Math.max(0, (event.clientX - rect.left) / rect.width)) * this.video.duration;
      if (!this.classList.contains('is-started')) this.play();
    }

    hoverBar(event) {
      if (!this.video.duration) return;
      const rect = this.seekBar.getBoundingClientRect();
      const pct = Math.min(100, Math.max(0, ((event.clientX - rect.left) / rect.width) * 100));
      this.tip.hidden = false;
      this.tip.style.left = `${pct}%`;
      this.tip.textContent = this.format((pct / 100) * this.video.duration);
    }
  }

  customElements.define('sok-film', SokFilm);
}
